import { useRef, useState } from 'react';
import { Icon } from '../components/Icon.js';
import { ResultCard } from '../components/ResultCard.js';
import { useReveal } from '../lib/motion.js';

const guarantees = [
  { icon: 'memory', label: 'Processado em memória' },
  { icon: 'cloud_off', label: 'Nada é guardado' },
  { icon: 'visibility_off', label: 'CPF não retorna' },
];

export function Payslip() {
  const root = useRef<HTMLDivElement>(null);
  const picker = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File>();
  const [state, setState] = useState<'idle' | 'loading' | 'error'>('idle');
  const [over, setOver] = useState(false);
  const [response, setResponse] = useState<unknown>();
  useReveal(root);

  const accept = (candidate: File | undefined) => {
    if (!candidate) return;
    setFile(candidate);
    setState('idle');
    setResponse(undefined);
  };

  const submit = async () => {
    if (!file) return;
    setState('loading');
    setResponse(undefined);
    try {
      const body = new FormData();
      body.append('file', file);
      const apiResponse = await fetch(`${import.meta.env.VITE_API_URL ?? 'http://localhost:3001'}/api/v1/holerites/extract`, { method: 'POST', body, cache: 'no-store' });
      const payload: unknown = await apiResponse.json();
      if (!apiResponse.ok) throw new Error();
      setResponse(payload);
      setState('idle');
    } catch {
      setState('error');
    }
  };

  return (
    <main className="page" ref={root}>
      <div className="page-head" data-reveal>
        <div className="page-head-copy">
          <p className="eyebrow">Raio-X</p>
          <h1 className="page-title">Leia seu holerite <em>sem deixá-lo salvo.</em></h1>
          <p className="lead">O PDF é tratado em memória, não é guardado e dados sensíveis não voltam na resposta.</p>
        </div>
      </div>

      <div className="payslip-grid">
        <section className="payslip-card glass" data-reveal>
          <button
            type="button"
            className={`dropzone${over ? ' over' : ''}`}
            onClick={() => picker.current?.click()}
            onDragOver={(event) => { event.preventDefault(); setOver(true); }}
            onDragLeave={() => setOver(false)}
            onDrop={(event) => { event.preventDefault(); setOver(false); accept(event.dataTransfer.files[0]); }}
          >
            <span className="dropzone-icon"><Icon name="upload_file" size={30} /></span>
            <strong>Arraste o PDF do holerite</strong>
            <span>ou escolha um arquivo · até 10 MB e 5 páginas</span>
            {file ? <span className="file-name">{file.name}</span> : null}
          </button>
          <input
            ref={picker} id="payslip" type="file" accept="application/pdf,.pdf" className="visually-hidden"
            aria-label="PDF do holerite" onChange={(event) => accept(event.target.files?.[0])}
          />

          <div className="guarantees">
            {guarantees.map((item) => (
              <span className="guarantee" key={item.label}><Icon name={item.icon} size={18} />{item.label}</span>
            ))}
          </div>

          <button type="button" className="btn-primary" disabled={!file || state === 'loading'} onClick={submit}>
            <Icon name={state === 'loading' ? 'progress_activity' : 'document_scanner'} size={20} className={state === 'loading' ? 'spin' : undefined} />
            {state === 'loading' ? 'Analisando…' : 'Analisar PDF'}
          </button>

          {state === 'error'
            ? <p role="alert" className="error-line"><Icon name="error" size={18} />Não foi possível analisar o arquivo. Verifique se é um PDF válido.</p>
            : null}
        </section>

        {response
          ? <ResultCard data={response} subtitle="Extração do holerite" />
          : (
            <aside className="result-empty" data-reveal>
              <span className="icon-box"><Icon name="receipt_long" size={28} /></span>
              <strong>Seu resultado aparecerá aqui.</strong>
              <p>O documento não cria histórico nesta aplicação.</p>
            </aside>
          )}
      </div>
    </main>
  );
}
